export function unwrapApiData(response) {
  if (response == null) {
    throw new Error('响应为空');
  }
  if (typeof response.code !== 'undefined') {
    if (Number(response.code) !== 0) {
      throw new Error(response.message || '请求失败');
    }
    return response.data;
  }
  return response;
}

/** 成功时返回 { data, message }，便于展示后端提示文案 */
export function unwrapApiResponse(response) {
  if (response == null) {
    throw new Error('响应为空');
  }
  if (typeof response.code !== 'undefined') {
    if (Number(response.code) !== 0) {
      throw new Error(response.message || '请求失败');
    }
    return { data: response.data, message: response.message || '' };
  }
  return { data: response, message: '' };
}

export function normalizeSegmentList(segments, coverEnabled = false) {
  if (!Array.isArray(segments)) {
    return [];
  }
  return segments
    .map(item => ({
      id: item.id,
      index: item.index,
      startMs: item.startMs,
      endMs: item.endMs,
      fileName: item.fileName,
      url: item.url,
      thumbnailUrl: item.thumbnailUrl,
      durationSeconds: item.durationSeconds,
      sizeBytes: item.sizeBytes,
      coverEnabled: item.coverEnabled != null ? !!item.coverEnabled : coverEnabled,
      score: item.score != null ? item.score : null,
    }))
    .sort((a, b) => a.index - b.index);
}
